import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import AnnouncementBar from '../components/AnnouncementBar';
import { XCircle, ArrowLeft } from 'lucide-react';

const PaymentCancel = () => {
  return (
    <div className="min-h-screen overflow-x-hidden">
      <AnnouncementBar />
      <Header />
      <div className="max-w-lg mx-auto px-4 sm:px-6 pt-10 pb-16 text-center">
        <div className="glass-card rounded-3xl p-8" data-testid="payment-cancel">
          <div className="w-16 h-16 mx-auto rounded-2xl bg-white/5 flex items-center justify-center mb-4">
            <XCircle className="w-9 h-9 text-white/60" />
          </div>
          <div className="text-white/50 text-[10px] font-bold uppercase tracking-widest mb-2">Paiement annulé</div>
          <h1 className="text-2xl font-bold text-white mb-2" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
            Aucune somme n’a été prélevée
          </h1>
          <p className="text-white/60 text-sm mb-6">
            Vous pouvez reprendre votre commande à tout moment.
          </p>
          <Link to="/collections" className="btn-primary inline-flex items-center gap-2 text-sm">
            <ArrowLeft className="w-4 h-4" /> Retour au catalogue
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
